/* tslint:disable */
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "./../../../../../../../shared/services/auth.service";
import {
  FormGroup,
  FormBuilder,
  FormArray,
  FormControl,
  ValidatorFn,
} from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { CamaraComercioEntry } from "src/app/shared/entrys/camara-comercio";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { EstablecimientoComercioService } from "../../../prestador/establecimiento-comercio/establecimiento-comercio.service";
import { CampoAdicionalCategoriaService } from "../../configuracion/campo-adicional-categoria/campo-adicional-categoria.service";
import { ModuloAyudaService } from "../../configuracion/modulo-ayuda/modulo-ayuda.service";
import { HttpEventType } from "@angular/common/http";
import * as FileSaver from "file-saver";
import { EstadisticosCamarasService } from "./estadisticos-camaras.service";

@Component({
  // tslint:disable-next-line:indent
  selector: "app-estadisticos-camaras",
  // tslint:disable-next-line:indent
  templateUrl: "./estadisticos-camaras.component.html",
  // tslint:disable-next-line:indent
  styleUrls: ["./estadisticos-camaras.component.scss"],
})
export class EstadisticosCamarasComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  headerTabla: Array<string>;
  formUsuario: FormGroup;
  camarasLista: Array<CamaraComercioEntry>;
  paginaActual: number;
  adminCC = RolesUsuario.AdministradorCC;
  columnas: Array<any> = [];
  columnasEnvio: any;
  // filtros
  filtro: FormGroup;
  formCheck: FormGroup;
  public isCollapsed = true;
  isExportar = true;
  camaraComercio: string;
  // Selects
  categoria: Array<any> = [];
  tipoRNT: Array<any> = [];
  exportarForm: FormGroup;
  fecha_inicio: any;
  exportarList = [
    // { id: "CAMARA", name: "Cámara de Comercio" },
    { id: "CATEGORIA", name: "Categoría" },
    {
      id: "INSCRITOS VIGENTES(ACTIVOS) HASTA FECHA INICIAL",
      name: "Inscritos Vigentes de Fecha Inicial (Activos)",
    },
    { id: "INSCRIPCIÓN", name: "Inscripción" },
    { id: "RENOVACIÓN", name: "Renovación" },
    { id: "ACTUALIZACIÓN", name: "Actualización" },
    { id: "REACTIVACIÓN", name: "Reactivación" },
    { id: "CANCELACIÓN", name: "Cancelación" },
    { id: "SUSPENSIÓN", name: "Suspensión" },
    {
      id: "NO APROBACIONES(DEVOLUCIONES) DE FECHA INICIAL A FECHA FINAL",
      name: "Devoluciones",
    },
    { id: "RECHAZOS DE FECHA INICIAL A FECHA FINAL", name: "Rechazos" },
    {
      id: "TOTAL REGISTROS VIGENTES FECHA FINAL ACTIVOS",
      name: "Total Registros Vigentes",
    },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private establecimientoComercioService: EstablecimientoComercioService,
    public authService: AuthService,
    private categoriaService: CampoAdicionalCategoriaService,
    private tipoRntService: ModuloAyudaService,
    private estadisticoService: EstadisticosCamarasService
  ) {
    this.createPagingTable();
    this.createForm();

    const selectAllControl = new FormControl(false);
    const formControl = this.exportarList.map(
      (control) => new FormControl(false)
    );
    this.exportarForm = this.formBuilder.group({
      exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
      selectAll: selectAllControl,
    });

    this.paginaActual = 1;
  }
  // tslint:disable-next-line:indent
  ngOnInit() {
    this.titleTable();
    this.onCamaraSelect();
    this.onCategoriaSelect();
    this.onTipoRNTSelect();
    this.onChanges();
  }

  createForm() {
    this.filtro = this.formBuilder.group({
      codigo_camara: [null],
      tipo_rnt: [null],
      categoria: [null],
      fecha_inicial: [null],
      fecha_final: [null],
    });

    this.formCheck = this.formBuilder.group({
      orders: new FormArray([]),
    });
  }

  createPagingTable() {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;
  }

  onConsultarEstablecimientos(page: number) {
    this.estadisticoService
      .getDataTable({ ...this.filtro.value, numeroPagina: page })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarEstablecimientos(value);
  }

  filtrar() {
    this.paginaActual = 1;
    this.createPagingTable();
    this.onConsultarEstablecimientos(1);
  }

  limpiar() {
    this.filtro.reset();
    this.createPagingTable();
    this.titleTable();
    this.onCamaraSelect();
    this.onCategoriaSelect();
    this.onTipoRNTSelect();
    this.onChanges();
  }

  titleTable() {
    this.headerTabla = [
      "Cámara de comercio",
      "Categoría",
      "Inscritos Vigentes de Fecha Inicial (Activos)",
      "Inscripciones",
      "Renovación",
      "Actualización",
      "Reactivación",
      "Cancelación",
      "Suspensión",
      "Devoluciones",
      "Rechazos",
      "Total Registros Vigentes Fecha Final (Activos)",
    ];
  }

  onCamaraSelect() {
    this.establecimientoComercioService.getCamaras().subscribe((resultado) => {
      if (resultado) {
        this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
        if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
          this.filtro
            .get("codigo_camara")
            .patchValue(this.authService.getCamaraUser());
          this.camaraComercio = this.camarasLista.find(
            (x) => x.codigo_camara === this.authService.getCamaraUser()
          ).desc_camara;
        }
      }
    });
  }

  onCategoriaSelect() {
    this.categoriaService.getCategoria().subscribe((resultado) => {
      if (resultado.result) {
        this.categoria = resultado.data;
      }
    });
  }

  onTipoRNTSelect() {
    this.tipoRntService.getTipoRnt().subscribe((resultado) => {
      if (resultado.result) {
        this.tipoRNT = resultado.data;
      }
    });
  }

  onChanges() {
    this.exportarForm.get("selectAll").valueChanges.subscribe((bool) => {
      this.exportarForm
        .get("exportarList")
        .patchValue(Array(this.exportarList.length).fill(bool), {
          emitEvent: false,
        });
    });

    this.exportarForm.get("exportarList").valueChanges.subscribe((val) => {
      const allSelected = val.every((bool) => bool);
      if (this.exportarForm.get("selecAll").value !== allSelected) {
        this.exportarForm
          .get("selectAll")
          .patchValue(allSelected, { emitEvent: false });
      }
    });
  }

  minSelectCheckbox(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        .map((control) => control.value)
        .reduce((prev, next) => (next ? prev + next : prev), 0);
      return totalSelected >= min ? null : { required: true };
    };
    return validator;
  }

  submit() {
    const selectedPreferences = this.exportarForm.value.exportarList
      .map((checked, index) => (checked ? this.exportarList[index].id : null))
      .filter((value) => value !== null);

    this.columnasEnvio = "CAMARA,";
    this.columnasEnvio += selectedPreferences.join();

    this.estadisticoService
      .generarExportarEstadistico({
        ...this.filtro.value,
        columnas: this.columnasEnvio,
      })
      .subscribe((resultado) => {
        if (resultado.type === HttpEventType.Response) {
          if (resultado.ok) {
            this.saveAsExcelFile(resultado.body, `reporte_estadistico.xlsx`);
          }
        }
      });
  }

  private saveAsExcelFile(data: any, fileName: string): void {
    FileSaver.saveAs(data, fileName);
  }

  onCheckDate(minDate: NgbDate) {
    this.fecha_inicio = {
      day: minDate.day,
      month: minDate.month,
      year: minDate.year,
    };
  }
}
